import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { MonthlyFeeSavePayload } from "gsintegrations";
import { terreiroRepository } from "../repositories/terreiroRepository";
import { financialQueryKeys } from "./useFinancialQueries";

type UpdateMonthlyFeeVariables = {
  terreiroId: string;
  monthlyFeeId: string;
  payload: MonthlyFeeSavePayload;
};

export function useUpdateMonthlyFeeMutation() {
  const qc = useQueryClient();

  return useMutation({
    mutationKey: ["monthly-fees", "update"],
    mutationFn: async ({
      terreiroId,
      monthlyFeeId,
      payload,
    }: UpdateMonthlyFeeVariables) =>
      terreiroRepository.updateMonthlyFee(terreiroId, monthlyFeeId, payload),
    onSettled: (_data, _error, variables) => {
      // Invalidate the list and the specific fee
      return Promise.all([
        qc.invalidateQueries({
          queryKey: ["monthly-fees", variables.terreiroId],
        }),
        qc.invalidateQueries({
          queryKey: [
            "monthly-fees",
            variables.terreiroId,
            variables.monthlyFeeId,
          ],
        }),
        qc.invalidateQueries({
          queryKey: financialQueryKeys.monthlyFees(variables.terreiroId),
        }),
      ]);
    },
    retry: 0,
  });
}
